<template>
  <footer class="footer">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14982.692478901385!2d-75.60810169206496!3d45.49146224042925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce1088c3300003%3A0x4c6f6d9f679f4418!2s922%20Boulevard%20Maloney%20E%20local%203%2C%20Gatineau%2C%20QC%20J8P%201H9!5e0!3m2!1sen!2sca!4v1736332653625!5m2!1sen!2sca" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="container" data-aos="fade-top">
      <!-- Colonne Informations sur l'entreprise -->
      <div class="footer-info">
        <h4 class="logo">
          <img src="@/assets/logo.png" alt="Logo" class="logo__img" />
          <span class="logo__text gold">
            Nyenyezia Forex
          </span>
        </h4>
        <p>{{ isEnglish ? 'Your trusted partner for currency exchange.' : "Votre partenaire fiable pour l'échange de devises." }}</p>
        <p>922 Maloney Est, local 3, Gatineau, QC, J8P 1H9, Canada</p>
        <p class=""><a href="tel:5144000939">514-400-0939</a></p>
      </div>

      <!-- Colonne Liens utiles -->
      <div class="footer-links">
        <h4 class="footer-subtitle">{{ isEnglish ? 'Useful Links' : 'Liens Utiles' }}</h4>
        <ul>
          <li><router-link :title="isEnglish ? 'Exchange Rates | Nyenyezia Forex' : 'Taux change | Nyenyezia Forex'" :to="localizedPath('/taux-de-change')">{{ isEnglish ? 'Exchange Rates' : 'Taux de change' }}</router-link></li>
          <li><router-link title="Services | Nyenyezia Forex" :to="localizedPath('/services')">Services</router-link></li>
          <li><router-link :title="isEnglish ? 'About | Nyenyezia Forex' : 'À propos | Nyenyezia Forex'" :to="localizedPath('/a-propos')">{{ isEnglish ? 'About' : 'À propos' }}</router-link></li>
          <li><router-link title="FAQ | Nyenyezia Forex" :to="localizedPath('/faq')">FAQ</router-link></li>
          <li><router-link title="Contact | Nyenyezia Forex" :to="localizedPath('/contact')">Contact</router-link></li>
          <li><router-link :title="isEnglish ? 'Français | Nyenyezia Forex' : 'English | Nyenyezia Forex'" :to="languageTogglePath">{{ isEnglish ? 'FR' : 'EN' }}</router-link></li>

        </ul>
      </div>

      <!-- Colonne Réseaux Sociaux -->
      <div class="footer-social">
        <h4 class="footer-subtitle">{{ isEnglish ? 'Follow Us' : 'Suivez-Nous' }}</h4>
        <div class="social-icons">
          <a href="#" class="social-icon"><img src="@/assets/icons/Facebook.svg" alt="Facebook" /></a>
          <a href="#" class="social-icon social-icon__x"><img src="@/assets/icons/x.svg" alt="X" /></a>
          <!-- <a href="#" class="social-icon"><img src="@/assets/icons/instagram.svg" alt="Instagram" /></a>
          <a href="#" class="social-icon"><img src="@/assets/icons/linkedin.svg" alt="LinkedIn" /></a> -->
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom" >
      <p>© 2024 Nyenyezia Inc. {{ isEnglish ? 'All rights reserved.' : 'Tous droits réservés.' }} <router-link class="footer-bottom__link" :to="localizedPath('/privacy-policy')">{{ isEnglish ? 'Privacy Policy' : 'Politique de Confidentialité' }}</router-link></p> 
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    },
    languageTogglePath() {
      if (this.isEnglish) {
        return this.$route.path.replace(/^\/en/, '') || '/';
      }
      return this.$route.path === '/' ? '/en' : '/en' + this.$route.path;
    }
  },
  methods: {
    localizedPath(path) {
      if (!this.isEnglish) return path;
      return path === '/' ? '/en' : '/en' + path;
    }
  }
};
</script>

<style scoped>

.logo {
  
}

.logo__img {
  width: 64px;
}
.logo__text {
  font-size: 32px;
  font-weight: bold;
}

.gold {
  color: #c39446;
}
.footer {
  background-color: #424242;
  border-top: 3px solid #45a5f6;
  color: #fff;
  padding: 0;
}

.footer .container {
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0;
  max-width: 1200px;
  margin: 0 auto; 
}

.footer-info, .footer-links, .footer-social {
  flex: 1;
  margin: 10px;
  font-size: 22px;
  padding: 0 90px;
}

.footer-title, .footer-subtitle {
  font-size: 1.2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #c39446;
}

.footer-info p, .footer-links ul, .footer-social {
  font-size: 18px;
}

.footer-links ul {
  list-style-type: none;
  padding: 0;
}

.footer-links li {
  margin: 5px 0;
}

a {
  text-decoration: none;
  color: #fff;
  transition: color 0.3s;
  font-weight: bold;
}

.footer-links a:hover {
  color: #c39446;
}

.social-icons {
}

.social-icon img {
  margin: 10px;
  width: 30px;
  height: 30px;
  transition: opacity 0.3s;
}
.social-icon__x img {
color: #fff;
}
.social-icon img:hover {
  opacity: 0.7;
}

.footer-bottom {
  margin-top: 20px;
  font-size: 0.8rem;
  color: #bbb;
  background-color: #001041;
  padding: 10px 0;
}

.footer-bottom__link {
  color: #bbb;
  text-decoration: none;
  border-left: 1px solid #535353;
  padding: 0 0 0 10px;
  margin: 0 0 0 6px;

}


@media (max-width: 768px) {
  .footer .container {
    flex-direction: column;
    text-align: left;
  }
}
</style>
